import { red } from "@mui/material/colors";
import { createTheme } from "@mui/material";

// A custom theme for this app
const theme = createTheme({
    components: {
        MuiButton: {
            styleOverrides: {
                root: ({ ownerState }) => ({
                    ...(ownerState.variant === "outlined" &&
                        ownerState.color === "primary" && {
                            borderColor: "#fff",
                            color: "#fff"
                        })
                })
            }
        }
    },
    palette: {
        primary: {
            main: "#5f0711",
            light: "#d5ac4e",
            dark: "#45050c"
        },
        secondary: {
            main: "#d5ac4e",
            light: "#eecf6d",
            dark: "#8b6220"
        },
        error: {
            main: red.A400
        },
        background: {
            default: "#5f0711"
        },
        text: {
            primary: "#fff",
            secondary: "#3e3e3e"
        }
    }
});

export default theme;
